module.exports = __webpack_public_path__ + "static/media/homepage_product.1577d1bd.svg";